
import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_PUBLIC_ENCRYPT_TOKEN || 'TABSA_DEFAULT_SECRET_KEY_2025';

export const encryptData = (data) => {
  const jsonString = JSON.stringify(data);
  return CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
};

export const encryptWithTimestamp = (data) => {
  const dataWithTimestamp = {
    ...data,
    timestamp: new Date().getTime(),
    nonce: CryptoJS.lib.WordArray.random(16).toString()
  };
  return encryptData(dataWithTimestamp);
};

export const encryptFields = (data, fieldsToEncrypt = []) => {
  const result = { ...data };
  fieldsToEncrypt.forEach(field => {
    if (result[field]) {
      result[field] = CryptoJS.AES.encrypt(
        result[field].toString(), 
        SECRET_KEY
      ).toString();
    }
  });
  return result;
};